//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminIncorporationController_failKyc,
  Response$AdminIncorporationController_failKyc$Status$200,
  ResponseContentType$AdminIncorporationController_failKyc,
} from '@api-client/generated/client';
import { useApiClientMutation } from '@hooks/useApiClientMutation';

export const useAdminIncorporationController_failKyc = () =>
  useApiClientMutation<
    Params$AdminIncorporationController_failKyc,
    Response$AdminIncorporationController_failKyc$Status$200[ResponseContentType$AdminIncorporationController_failKyc]
  >({ method: 'AdminIncorporationController_failKyc' });
